export default "__VITE_ASSET__DcZ2VFWZ__"